module.exports = __webpack_public_path__ + "img/looking-new-partners-small.01fa3493.png";